exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nhtml, body, game-root {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0;\n  padding: 0;\n  font-family: 'Raleway', sans-serif;\n  color: #222; }\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/HeinousTugboat/Projects/survivalism/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/HeinousTugboat/Projects/survivalism/node_modules/postcss-loader?{"ident":"postcss"}!C:/Users/HeinousTugboat/Projects/survivalism/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!C:/Users/HeinousTugboat/Projects/survivalism/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles